import { Controller } from '@hotwired/stimulus';
import { jquery } from 'utils/jquery';

// #AI: NProgress is loaded via Sprockets as a global variable
const NProgress = window.NProgress;

export default class extends Controller {
  static targets = ['switch'];

  connect() {
    this.syncSwitch();
  }

  load(value) {
    // This should be replaced with fetch API once we're not using jquery
    // anymore
    const $ = jquery();
    if (!$) {
      console.error('[WeightSwitchController] jQuery not available');
      return;
    }

    $.get(this.data.get('url'), { weight: value })
      .done((response) => {
        this.element.innerHTML = response;
        this.checked = value;
        this.syncSwitch();
        NProgress.done();
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        console.error('Request failed:', textStatus, errorThrown);
        alert(
          'An error occurred while processing your request. Please try again.'
        );
        NProgress.done();
      });
  }

  toggle(event) {
    NProgress.start();
    this.load(event.target.checked);
  }

  get checked() {
    return this.data.get('checked') === 'true';
  }

  set checked(value) {
    this.data.set('checked', value ? 'true' : 'false');
    this.syncSwitch();
  }

  syncSwitch() {
    this.switchTarget.checked = this.checked;
  }
}
